import ApiService from '../../../utils/fetch';

const BASE_URL = process.env.REACT_APP_BASE_URL;


export const fetchFilters = async (
  category = '',
  subCategory = '',
  type = '',
  orderType = ''
) => {
  try {
    const capitalize = (s = '') =>
      s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : '';

    const isSupplyOrder =
      category === 'supply' && subCategory === 'order';

    const response = await ApiService.get(`${BASE_URL}filter/`, {
      params: {
        category: capitalize(category),
        subCategory: capitalize(subCategory),
        type: capitalize(type),
        ...(isSupplyOrder && {
          orderType: orderType,
        }),
      },
    });

    return response.data;
  } catch (error) {
    console.error('Failed to fetch filters:', error);
    throw error;
  }
};

export const fetchCardTotal = async (category = '', subCategory = '', type = '') => {
  try {
    // Ensure the type is a string or aconsole.log('hi', subCategory)
    const capitalize = (s) => s[0].toUpperCase() + s.slice(1).toLowerCase();
    const response = await ApiService.get(`${BASE_URL}dashboard/details`, {
      params: {
        category: capitalize(category),
        subCategory: capitalize(subCategory),
        type: capitalize(type),
      },
    });
    return response.data; // Expected: { exceptions: {...}, states: {...} }
  } catch (error) {
    console.error('Failed to fetch filters:', error);
    throw error;
  }
};


export const updateCount = async (payload, orderType) => {
  const url = orderType
    ? `${BASE_URL}filter/updateCounts?orderType=${orderType}`
    : `${BASE_URL}filter/updateCounts`;

  const response = await ApiService.post(url, payload);
  return response.data;
};




